import { UuidType } from "../types";

export const logErrorMessage = (uuid?: UuidType): void => {
  const traceId = uuid?.traceId;
  const spanId = uuid?.spanId;
  if (traceId && spanId) {
    console.log(
      `Server error occurred. Please contact support to resolve the issue with traceId: ${traceId} and spanId: ${spanId}`
    );
  }
};
